export default __webpack_public_path__ + "static/banks-75db37410ba7106a929ab7d5cc593dea8b0c2136ec9c23f60e10ff2664ae2d9f.png";